import * as React from "react";
import { TabsContent } from "@/taskpane/components/ui/tabs";
import { Button } from "@/taskpane/components/ui/button";
import { Input } from "@/taskpane/components/ui/input";
import { Copy, Twitter, Linkedin, Facebook } from "lucide-react";

interface ReferralLinkFormProps {
  referralLink: string;
  onCopyLink: () => void;
  onSocialShare: (platform: "twitter" | "linkedin" | "facebook") => void;
}

const ReferralLinkForm: React.FC<ReferralLinkFormProps> = ({
  referralLink,
  onCopyLink,
  onSocialShare,
}) => (
  <TabsContent value="link" className="mt-4 space-y-6">
    <div className="text-center">
      <h3 className="text-sm font-semibold mb-1">Share Your Referral Link</h3>
      <p className="text-xs text-neutral-400">
        Copy your unique referral link and share it anywhere!
      </p>
    </div>

    <div className="space-y-1">
      <p className="text-xs text-neutral-400">Your Referral Link</p>
      <div className="flex gap-2">
        <Input
          readOnly
          value={referralLink}
          className="bg-neutral-700 text-neutral-200 font-mono text-xs h-8"
        />
        <Button
          onClick={onCopyLink}
          className="bg-primary-300 hover:bg-primary-300-pressed text-neutral-white whitespace-nowrap h-8 text-xs"
        >
          <Copy className="mr-2 h-3 w-3" />
          Copy
        </Button>
      </div>
    </div>

    <div className="flex flex-col items-center gap-3">
      <span className="text-xs font-semibold">Share on Social Media</span>
      <div className="flex gap-2">
        <Button
          size="sm"
          onClick={() => onSocialShare("twitter")}
          className="bg-[#1DA1F2] hover:bg-[#1a91da] text-white border-none h-8 text-xs"
        >
          <Twitter className="mr-2 h-3 w-3" />
          Twitter
        </Button>
        <Button
          size="sm"
          onClick={() => onSocialShare("linkedin")}
          className="bg-[#0077B5] hover:bg-[#006093] text-white border-none h-8 text-xs"
        >
          <Linkedin className="mr-2 h-3 w-3" />
          LinkedIn
        </Button>
        <Button
          size="sm"
          onClick={() => onSocialShare("facebook")}
          className="bg-[#4267B2] hover:bg-[#365899] text-white border-none h-8 text-xs"
        >
          <Facebook className="mr-2 h-3 w-3" />
          Facebook
        </Button>
      </div>
    </div>
  </TabsContent>
);

export default ReferralLinkForm;
